import { CasaDecimalUtils } from 'px-components';

const DEFAULT_PRECISION = 20;

function getPrecision(item) {
  if (item?.casasDecimais === null || item?.casasDecimais === undefined) {
    return CasaDecimalUtils.DEFAULT_CASAS_DECIMAIS;
  }
  return parseFloat(item.casasDecimais);
}

export {
  DEFAULT_PRECISION,
  getPrecision,
};
